import { render, staticRenderFns } from "./surveyFinishOwn.vue?vue&type=template&id=605ff765&scoped=true"
import script from "./surveyFinishOwn.vue?vue&type=script&lang=js"
export * from "./surveyFinishOwn.vue?vue&type=script&lang=js"
import style0 from "./surveyFinishOwn.vue?vue&type=style&index=0&id=605ff765&prod&lang=less&scoped=true"
import style1 from "./surveyFinishOwn.vue?vue&type=style&index=1&id=605ff765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ff765",
  null
  
)

export default component.exports